module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showFlag),
      expression: "showFlag"
    }],
    staticClass: "food"
  }, [_h('div', {
    staticClass: "fond-content"
  }, [_h('div', {
    staticClass: "image-header"
  }, [_h('img', {
    attrs: {
      "src": _vm.food.image,
      "alt": ""
    }
  }), " ", _h('div', {
    staticClass: "back",
    on: {
      "click": _vm.hide
    }
  }, [_h('i', {
    staticClass: "iconfont icon-weibiaoti6-copy"
  })])]), " ", _h('div', {
    staticClass: "content"
  }, [_h('h1', {
    staticClass: "title"
  }, [_vm._s(_vm.food.name)]), " ", _h('div', {
    staticClass: "detail"
  }, [_h('span', {
    staticClass: "sell-count"
  }, ["月售" + _vm._s(_vm.food.sellCount) + "份"]), " ", _h('span', {
    staticClass: "rating"
  }, [" 好评率" + _vm._s(_vm.food.rating) + "%"])]), " ", _h('div', {
    staticClass: "price"
  }, [_h('span', {
    staticClass: "now"
  }, ["￥" + _vm._s(_vm.food.price)]), " ", _h('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.oldPrice),
      expression: "food.oldPrice"
    }],
    staticClass: "old"
  }, ["￥" + _vm._s(_vm.food.oldPrice)])]), " ", _h('div', {
    staticClass: "cartControl-wrapper"
  }, [_h('cartControl', {
    attrs: {
      "food": _vm.food
    }
  })]), " ", _h('transition', {
    attrs: {
      "name": "buy"
    }
  }, [_h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.count || _vm.food.count === 0),
      expression: "!food.count || food.count === 0"
    }],
    staticClass: "buy",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.addFirst($event)
      }
    }
  }, ["\n            加入购物车\n          "])])]), " ", _h('split'), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.info),
      expression: "food.info"
    }],
    staticClass: "info"
  }, [_h('h1', {
    staticClass: "title"
  }, ["商品信息"]), " ", _h('p', {
    staticClass: "text"
  }, [_vm._s(_vm.food.info)])]), " ", _h('split'), " ", _h('div', {
    staticClass: "rating"
  }, [_h('h1', {
    staticClass: "title"
  }, ["商品评价"]), " ", _h('ratingselect', {
    attrs: {
      "select-type": _vm.selectType,
      "only-content": _vm.onlyContent,
      "desc": _vm.desc,
      "ratings": _vm.food.ratings
    },
    on: {
      "increment": _vm.incrementTotal
    }
  }), " ", _h('div', {
    staticClass: "rating-wrapper"
  }, [_h('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.food.ratings && _vm.food.ratings.length),
      expression: "food.ratings && food.ratings.length"
    }]
  }, [_vm._l((_vm.food.ratings), function(rating) {
    return _h('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.needShow(rating.rateType, rating.text)),
        expression: "needShow(rating.rateType, rating.text)"
      }],
      staticClass: "rating-item border-1px"
    }, [_h('div', {
      staticClass: "user"
    }, [_h('span', {
      staticClass: "name"
    }, [_vm._s(rating.username)]), " ", _h('img', {
      staticClass: "avatar",
      attrs: {
        "width": "12",
        "height": "12",
        "src": rating.avatar,
        "alt": ""
      }
    })]), " ", _h('div', {
      staticClass: "time"
    }, [_vm._s(_vm._f("formatDate")(rating.rateTime))]), " ", _h('p', {
      staticClass: "text"
    }, [_h('i', {
      staticClass: "iconfont",
      class: {
        'icon-damuzhi': rating.rateType === 0, 'icon-down': rating.rateType === 1,
      }
    }), "\n                " + _vm._s(rating.text) + "\n              "])])
  })]), " ", _h('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.food.ratings || _vm.food.ratings.length === 0),
      expression: "!food.ratings || food.ratings.length === 0"
    }],
    staticClass: "no-rating"
  })])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.vue-loader@10.0.2/lib/template-compiler.js?id=data-v-9b2d2780!./~/.vue-loader@10.0.2/lib/selector.js?type=template&index=0!./src/components/food/food.vue
// module id = 52
// module chunks = 1